import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import { PickersActionBarProps } from '@mui/x-date-pickers/PickersActionBar';
import { useLocaleText } from '@mui/x-date-pickers/internals';

function CustomPickersActionBar({
  onAccept,
  onCancel,
  actions,
  ...other
}: PickersActionBarProps) {
  const localeText = useLocaleText();

  const actionsArray = Array.isArray(actions) ? actions : [];

  if (actionsArray.length === 0) return null;

  return (
    <DialogActions {...other}>
      {actionsArray.includes('cancel') && (
        <Button variant="outlined" color="inherit" onClick={onCancel}>
          {localeText.cancelButtonLabel}
        </Button>
      )}
      {actionsArray.includes('accept') && (
        <Button variant="contained" color="primary" onClick={onAccept}>
          {localeText.okButtonLabel}
        </Button>
      )}
    </DialogActions>
  );
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function DatePicker(_theme: unknown) {
  return {
    MuiMobileDateTimePicker: {
      defaultProps: {
        components: {
          ActionBar: CustomPickersActionBar,
        },
      },
    },
    MuiMobileDatePicker: {
      defaultProps: {
        components: {
          ActionBar: CustomPickersActionBar,
        },
      },
    },
    MuiMobileTimePicker: {
      defaultProps: {
        components: {
          ActionBar: CustomPickersActionBar,
        },
      },
    },
  };
}
